// @flow

import * as React from 'react';

import { Base, Text } from '@gandi/ui';

import { divideTldFromBaseDomain } from 'src/modules/domain';

import { DiscountPercentBadge } from '../../DiscountPercentBadge';
import { useDomainBundle } from '../modules';

import styles from './DomainBundle.scss';

export function BundleProductDescription(): React.MixedElement | null {
  const { bundle, formattedDiscount } = useDomainBundle();

  if (!bundle?.items?.length) return null;

  const tlds = bundle.items.map(
    item => `.${divideTldFromBaseDomain(item.fqdn).tld}`,
  );
  // $FlowFixMe[incompatible-use] length of bundle.items is checked above
  const baseDomainName = divideTldFromBaseDomain(bundle.items[0].fqdn).baseFqdn;

  return (
    <Base
      flex
      size="bigger"
      weight="semibold"
      gap="xsmall"
      flexAlignItemsCenter
      flexWrap
    >
      <Text overflow="break">{baseDomainName} </Text>

      <span>
        {tlds.map((tld, i) => {
          const key = `bundle-${bundle.type}-tld-${tld}`;
          const isLast = i === tlds.length - 1;
          return (
            <React.Fragment key={key}>
              <span className={styles.tldBadge}>{tld}</span>
              {
                /* simulate a join() */
                !isLast && ' + '
              }
            </React.Fragment>
          );
        })}
      </span>
      <DiscountPercentBadge formattedDiscount={formattedDiscount} />
    </Base>
  );
}
